import { ConditionalFormatInput } from "../../Common/ConditionBuilder/ConditionalFormatInput";

export const ConditionalFormattingProperty = {
  propertyName: "ConditionalFormatting",
  propertyDisplay: "Conditional Formatting",
  propertyType: "array",
  propertyCategory: "Logic",
  renderer: function ({ handlePropertyChange, currentPropertyValues, isGalleryEditor }) {
    return (
      <ConditionalFormatInput
        handlePropertyChange={handlePropertyChange}
        defaultValue={currentPropertyValues?.[this.propertyName] || []}
        currentPropertyValues={currentPropertyValues}
        isGalleryEditor={isGalleryEditor}
      />
    );
  },
};
